import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomepageComponent } from './homepage/homepage.component';
import { MsalGuard } from '@azure/msal-angular';
import {
  InformationsAndContactPageComponent
} from '@app/informations-and-contact-page/informations-and-contact-page.component';
import { DefaultRedirectGuard } from '@app/security/default-redirect.guard';

const routes: Routes = [
  {
    path: '',
    component: HomepageComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        canActivate: [DefaultRedirectGuard],
        children: [],
        pathMatch: 'full',
      },
      {
        path: 'finder',
        loadChildren: () =>
          import('./scenarios/scenario-routing.module').then(m => m.ScenarioRoutingModule),
      },
      {
        path: 'price-card',
        loadChildren: () =>
          import('./price-card/price-card-routing.module').then(m => m.PriceCardRoutingModule),
      },
      {
        path: 'info',
        component: InformationsAndContactPageComponent
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin-routing.module').then(m => m.AdminRoutingModule),
      },
      {
        path: '**',
        redirectTo: 'info',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
